import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLifetimeSecurity = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "lifetimeSecurity",
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "lock",
			transform: "translate(11.563 10.313)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "bar",
				d: "M14.291,11.844V10.159A1.909,1.909,0,0,0,12.382,8.25h0a1.909,1.909,0,0,0-1.909,1.909v1.685",
				transform: "translate(-8.944 -8.25)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}), /* @__PURE__ */ _jsx("path", {
				id: "lock-2",
				"data-name": "lock",
				d: "M14.875,11.126H10.5a1.25,1.25,0,0,0-1.25,1.25v2.655a1.25,1.25,0,0,0,1.25,1.25h4.375a1.25,1.25,0,0,0,1.25-1.25V12.376a1.25,1.25,0,0,0-1.25-1.25Z",
				transform: "translate(-9.25 -7.531)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12855",
			"data-name": "Path 12855",
			d: "M0,0H30V30H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "shield",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "background",
				d: "M0,0H30V30H0Z",
				fill: "none"
			}), /* @__PURE__ */ _jsx("path", {
				id: "path",
				d: "M24,13.3A12.931,12.931,0,0,1,14.65,25.41a2.392,2.392,0,0,1-1.3,0A12.929,12.929,0,0,1,4,13.3V8.267A2.5,2.5,0,0,1,5.554,5.954l6.08-2.487a6.245,6.245,0,0,1,4.734,0l6.08,2.487A2.5,2.5,0,0,1,24,8.267Z",
				transform: "translate(1 0.75)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			})]
		})
	]
});
export default SvgLifetimeSecurity;
